import { AppUsuario } from '../../../core/models/appUsuario.model';
import { AppUsuarioService } from '../../../core/services/appUsuarioService.service';
import { AppRolesService } from '../../../core/services/appRoles.service';
import { AppSeccionesService } from '../../../core/services/appSeccionesService.service';
import { AppSendInviteService } from '../../../core/services/appSendInviteService.service';
import { HttpParams } from '@angular/common/http';
import { AfterContentChecked, AfterContentInit, AfterViewInit, Component, EventEmitter, Inject, OnInit, Output, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';

import * as XLSX from 'xlsx';
import { LicenseCheckerService } from '../../../core/helper/licenseChecker';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { ImportarExcelDialog } from '../../importar-excel-dialog/importar-excel-dialog.component';

@Component({
  selector: 'app-empleados-list',
  templateUrl: './empleados-list.component.html',
  styleUrls: ['./empleados-list.component.scss'],
  providers: [AppUsuarioService, AppRolesService, AppSeccionesService, AppSendInviteService]
})

export class EmpleadosListComponent extends ListFormBase<AppUsuario> implements AfterViewInit, OnInit {

  // Propiedades del panel contenedor
  panelIcon = 'person'; // Material icon
  panelTitle = 'Empleados';
  panelDescription = 'Listado de los usuarios dado un entorno';

  roleName: String;
  sectionName: String;
  exporting = false;
  selectedRows = [];
  errorLog = [];
  showProgressPopup = false;
  currentInviteIndex = 0;
  totalInvites = 0;


  conectiaLicence: boolean;
  livesLicence: boolean;

  constructor(
    protected _modelService: AppUsuarioService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected rolesService: AppRolesService,
    protected sectionsService: AppSeccionesService,
    protected sendInviteService: AppSendInviteService,
    private licenseChecker: LicenseCheckerService,
    protected importExcelDialog: MatDialog,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document

  ) {
    super(_modelService, _router, _route, _messageDialog, AppUsuario);
    this.isCrud = true;
  }

  ngOnInit(): void {
    this.conectiaLicence = this.licenseChecker.checkLicense("conectia");
    this.livesLicence = this.licenseChecker.checkLicense("livesHR");
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getDataSource();
    });
  }

  showMessage(title: string, message: string) {
    this._messageDialog.ShowMessage(message, title);
  }

  newFeatureAlert() {

    this.showMessage('Funcionalidad próximamente disponible', 'Esta funcionalidad estará disponible próximamente');
  }


  updateSelectedRows(e) {
    const selectedRowsDataArr = [];

    e.selectedRowsData.forEach(row => {
      const selectedRowKeys = e.component.getSelectedRowKeys();
      const rowIndex = selectedRowKeys.findIndex(rowKey => rowKey.user1 === row.user1);
      selectedRowKeys[rowIndex] && selectedRowsDataArr.push(selectedRowKeys[rowIndex]);
    });

    if (selectedRowsDataArr.length < 1) {
      e.component.deselectAll();
    }

    this.selectedRows = selectedRowsDataArr;
  }


  sendInvite(data, multiple = false): Promise<void> {
    return new Promise((resolve, reject) => {
      // Validaciones de correo y acceso a la app
      if (!data.mail) {
        if (!multiple) {
          this._messageDialog.ShowAlert(
            'El empleado no tiene correo electrónico',
            'No se puede enviar la invitación'
          );
        }
        return reject(new Error('El empleado no tiene correo electrónico'));
      }

      if (!data.enabled) {
        if (!multiple) {
          this._messageDialog.ShowAlert(
            'El empleado no tiene acceso a la app habilitado',
            'No se puede enviar la invitación'
          );
        }
        return reject(new Error('El empleado no tiene acceso a la app habilitado'));
      }

      // Datos de la invitación
      const requestData = {
        user: data.user1,
        enabled: data.enabled,
        mail: data.mail,
        company: data.company.company1
      };

      // Envío de la invitación
      this.sendInviteService.sendInviteModel(requestData).subscribe(
        (response: any) => {
          // Si "multiple" es false, mostrar el mensaje de invitación enviada
          if (!multiple) {
            this._messageDialog.ShowMessage(
              `Invitación enviada a ${data.mail}`,
              'Enviada'
            );
          }
          resolve();
        },
        (error) => {
          // Manejo del error, mostrar alerta si "multiple" es false
          if (!multiple) {
            this._messageDialog.ShowAlert(
              `El proceso de invitación falló`,
              'No se puede enviar la invitación'
            );
          }
          reject(error);
        }
      );
    });
  }

  getFormattedDate(data: any): string {

    if (data.dropDate) {
      const date = new Date(data.dropDate);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses son de 0-11 en JavaScript
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;

    } else {
      return ``;
    }
  }

  /* comportamiento para que se muestre si/no en vez de un checkbox */
  transformBooleanToYesNo(data: any): string {
    return data && data.enabled ? 'Si' : 'No';
  }

  onExporting(e) {
    this.exporting = true;
    setTimeout(() => { this.exporting = false; }, 300);
  }

  async onClickInvite() { // Reinicia la lista de errores
    this.errorLog = [];
    this.totalInvites = this.selectedRows.length;
    this.currentInviteIndex = 0;
    this.showProgressPopup = true;


    for (const row of this.selectedRows) {
      try {
        await this.sendInvite(row, true);  // Enviar invitación en modo múltiple
      } catch (error) {
        // Guardar el error en el log de errores con nameWithNif y detalles adicionales
        this.errorLog.push({
          'Empleado': row.nameWithNif,
          'Nombre de usuario': row.mail,
          'Sección': row.section.name,
          'Empresa': row.company.name,
          'Acceso App': row.enabled ? 'Sí' : 'No',
          'Fecha de baja': row.dropDate,
          'Error': error.message || 'Error desconocido'
        });
      } finally {
        this.currentInviteIndex++;
      }
    }
    this.showProgressPopup = false;

    if (this.errorLog.length > 0) {
      this._messageDialog.ShowInviteErrorsWithDownload(
        this.errorLog,
        'Proceso completado con errores',
        () => this.exportErrorLogToExcel()
      );
    } else {
      this._messageDialog.ShowMessage(
        'Todas las invitaciones fueron enviadas correctamente.',
        'Completado'
      );
    }
  }

  buildErrorMessage(): string {
    let errorMessage = 'Se han encontrado errores en las siguientes invitaciones:<ul>';

    this.errorLog.forEach(error => {
      errorMessage += `<li>${error['nameWithNif']}: ${error.error}</li>`;
    });

    // Agrega el botón para descargar el Excel al final del mensaje
    errorMessage += `
      </ul>
      <br/>
      <button id="downloadExcel" class="btn btn-primary">
        Descargar Errores en Excel
      </button>
    `;

    return errorMessage;
  }


  exportErrorLogToExcel() {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.errorLog);

    // Ajustar el ancho de las columnas
    worksheet['!cols'] = [
      { wch: 50 },
      { wch: 30 },
      { wch: 20 },
      { wch: 40 },
      { wch: 20 },
      { wch: 30 },
      { wch: 100 },
    ];

    const workbook: XLSX.WorkBook = { Sheets: { 'Errores': worksheet }, SheetNames: ['Errores'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveAsExcelFile(excelBuffer, 'Errores_Invitaciones_LivesHR');
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    const EXCEL_EXTENSION = '.xlsx';
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = fileName + EXCEL_EXTENSION;
    link.click();
  }

  onClickAdd() {
    this._router.navigate(['new'], {
      relativeTo: this._activatedRoute
    });
  }

  onClickImport() {
    const dialogRef = this.importExcelDialog.open(ImportarExcelDialog, {
      width: '50%',
      data: { templateType: 'users' },
    });

    const dialogContainer = this.document.querySelector('.mat-dialog-container');
    if (dialogContainer) {
      this.renderer.setStyle(dialogContainer, 'background-color', '#dadada');
    }

    dialogRef.afterClosed().subscribe(result => {
      this.getDataSource();
    });
  }


}